// Motifs illustrés en SVG (data URI) — superposés en transparence sur les fonds de carte,
// comme les fonds travaillés des réalisations clients (ex. O'tentica).

const enc = (svg) => `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;

const tile = (body, size = 160) =>
  `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">${body}</svg>`;

export function patternUri(kind, color = "#FFFFFF") {
  const s = `fill="none" stroke="${color}" stroke-opacity="0.14" stroke-width="2"`;
  const dot = `fill="${color}" fill-opacity="0.14" stroke="none"`;
  const tiles = {
    gastronomie: tile(
      `<g ${s}><circle cx="42" cy="42" r="20"/><path d="M112 18 L144 62 L80 62 Z" stroke-linejoin="round"/><path d="M28 124 q 22 -28 44 0 q -22 28 -44 0 Z"/><circle cx="122" cy="122" r="11"/><path d="M16 84 h 30" stroke-linecap="round"/><path d="M96 96 q 10 -14 24 -12"/></g><circle cx="142" cy="26" r="3.5" ${dot}/><circle cx="60" cy="140" r="3" ${dot}/>`
    ),
    botanique: tile(
      `<g ${s}><path d="M40 130 Q 20 80 40 30 Q 60 80 40 130 Z"/><path d="M40 118 V 44"/><path d="M40 100 q -14 -8 -18 -22 M40 100 q 14 -8 18 -22 M40 78 q -12 -7 -15 -19 M40 78 q 12 -7 15 -19"/><path d="M116 60 Q 102 30 116 8 Q 130 30 116 60 Z"/><path d="M116 52 V 16"/></g><circle cx="130" cy="120" r="14" ${s}/><circle cx="130" cy="120" r="6" ${dot}/>`
    ),
    arcs: tile(
      `<g ${s}><path d="M0 60 A 60 60 0 0 1 60 0"/><path d="M0 96 A 96 96 0 0 1 96 0"/><path d="M0 132 A 132 132 0 0 1 132 0"/><path d="M160 100 A 60 60 0 0 0 100 160"/><path d="M160 64 A 96 96 0 0 0 64 160"/></g><circle cx="136" cy="136" r="4" ${dot}/>`
    ),
    vagues: tile(
      `<g ${s}><path d="M-8 40 q 20 -18 40 0 t 40 0 t 40 0 t 40 0 t 40 0"/><path d="M-8 84 q 20 -18 40 0 t 40 0 t 40 0 t 40 0 t 40 0"/><path d="M-8 128 q 20 -18 40 0 t 40 0 t 40 0 t 40 0 t 40 0"/></g><circle cx="34" cy="148" r="3" ${dot}/><circle cx="126" cy="12" r="3" ${dot}/>`
    ),
  };
  return enc(tiles[kind] || tiles.arcs);
}
